var $35be4b468e070ce1$exports = {};
$35be4b468e070ce1$exports = {
    "collapse": `\u{6536}\u{5408}`,
    "expand": `\u{5C55}\u{958B}`
};


export {$35be4b468e070ce1$exports as default};
//# sourceMappingURL=zh-TW.module.js.map
